import { useTheme } from '../context/ThemeContext.jsx';

export default function DuplicatePrompt({ duplicates, onSkip, onReplace, onCancel }) {
  const { theme } = useTheme();

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: 440, maxHeight: '80vh',
          background: theme.bgElevated,
          border: `1px solid ${theme.borderHover}`,
          borderRadius: 14, boxShadow: '0 24px 80px rgba(0,0,0,0.4)',
          display: 'flex', flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div style={{
          padding: '18px 20px 14px',
          borderBottom: `1px solid ${theme.borderLight}`,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <span style={{ fontSize: 20 }}>⚠️</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: theme.text }}>
              Duplicate Fonts Detected
            </span>
          </div>
          <div style={{ fontSize: 12, color: theme.textMuted, paddingLeft: 30 }}>
            {duplicates.length} font{duplicates.length !== 1 ? 's' : ''} already exist in your library.
            What would you like to do?
          </div>
        </div>

        {/* Duplicate list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 20px' }}>
          {duplicates.map((d, i) => (
            <div
              key={i}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '7px 0',
                borderBottom: i < duplicates.length - 1 ? `1px solid ${theme.borderLight}` : 'none',
              }}
            >
              <div style={{
                width: 6, height: 6, borderRadius: '50%',
                background: theme.yellow || '#F59E0B', flexShrink: 0,
              }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: 12, fontWeight: 600, color: theme.textSecondary,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>{d.existingFamily}</div>
                <div style={{ fontSize: 10, color: theme.textGhost }}>
                  {d.name} → already in library
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div style={{
          padding: '14px 20px',
          borderTop: `1px solid ${theme.borderLight}`,
          display: 'flex', gap: 8, flexDirection: 'column',
        }}>
          <button
            onClick={onSkip}
            style={{
              padding: '10px 0', borderRadius: 8, border: 'none',
              background: 'linear-gradient(135deg, #4F8EF7, #7C5CFC)',
              color: '#fff', fontSize: 13, fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Skip Duplicates <span style={{ opacity: 0.8, fontSize: 11 }}>(Recommended)</span>
          </button>
          <button
            onClick={onReplace}
            style={{
              padding: '9px 0', borderRadius: 8,
              border: `1px solid ${theme.borderMedium}`,
              background: theme.bgTertiary,
              color: theme.textSecondary, fontSize: 13, fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Replace Existing
          </button>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 0', borderRadius: 8, border: 'none',
              background: 'none',
              color: theme.textFaint, fontSize: 12,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Cancel Upload
          </button>
        </div>
      </div>
    </div>
  );
}
